import { InputAdornment, TextField } from "@mui/material";
import { ErrorMessage, Field, FormikProps, FormikValues, getIn, useField, useFormikContext } from "formik";


export default function InputField(props: any) {
  const { id, name, label, multiline, rows, variant, type, suffix, disabled, onFocus } = props;

  const [field] = useField(props);
  const hasValue = Boolean(field.value);
  const { setFieldValue } = useFormikContext();
  const formik: FormikProps<FormikValues> = useFormikContext();

  if (field.value === "" && field.name === "User.Contact.SecondaryEmail.Email") {
    setFieldValue("User.Contact.SecondaryEmail", undefined);
  }

  if (field.value === "" && field.name === "Patient.Height") {
    setFieldValue("Patient.Height", 1);
  }

  if (field.value === "" && field.name === "Patient.Weight") {
    setFieldValue("Patient.Weight", 1);
  }

  return (
    <Field
      as={TextField}
      fullWidth
      id={id}
      label={label}
      name={name}
      type={type}
      disabled={disabled}
      InputProps={{
        endAdornment: <InputAdornment position="end">{suffix}</InputAdornment>,
      }}
      InputLabelProps={{
        shrink: hasValue || field.value === 0,
      }}
      multiline={multiline}
      rows={rows}
      variant={variant}
      helperText={<ErrorMessage name={name} />}
      error={getIn(formik.touched, name) && getIn(formik.errors, name)}
      onFocus={onFocus}      
    />
  );
}
